import { initializeApp, getApps, getApp } from 'firebase/app';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager, getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

export const firebaseConfig = {
  apiKey: "AIzaSyAQOdTHUetpugnCw7toVIC-eiFoaVFe4UA",
  authDomain: "claimsofdrinkyard.firebaseapp.com",
  projectId: "claimsofdrinkyard",
  storageBucket: "claimsofdrinkyard.firebasestorage.app",
  messagingSenderId: "461320057156",
  appId: "1:461320057156:web:13b0cf408ddb51278da711"
};

const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

let firestoreDb;
try {
  firestoreDb = initializeFirestore(app, {
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager()
    })
  });
} catch (e) {
  firestoreDb = getFirestore(app);
}

export const db = firestoreDb;
export const auth = getAuth(app);
